import { render, staticRenderFns } from "./CloseDialog.vue?vue&type=template&id=1556c171&scoped=true&"
import script from "./CloseDialog.vue?vue&type=script&lang=js&"
export * from "./CloseDialog.vue?vue&type=script&lang=js&"
import style0 from "./CloseDialog.vue?vue&type=style&index=0&id=1556c171&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1556c171",
  null
  
)

export default component.exports